import React from 'react';

import { clubLogo } from '../domain/clubs';

export default function PlayerDisplay({ player, children }) {
    if (!player) {
        return (
            <div className="player">
                <div className="panel">
                    <div className="player-empty">
                        Seleziona un giocatore per visualizzare i dettagli
                    </div>
                </div>
            </div>
        );
    }

    const fvm = Number.parseFloat(player['FVM Attuale']);

    return (
        <div className="player">
            <div className="panel">
                <div className="panel-body player">
                    <div className="player-head">
                        <div className="player-figure">
                            {player['URL Immagine'] && (
                                <img src={player['URL Immagine']} alt={player['Nome Completo']} />
                            )}
                        </div>
                        <h5 className="player-name">{player['Nome Completo']}</h5>
                        <p className="player-stat">
                            <strong>Ruolo:</strong> {player.Ruolo} <br />
                            <strong>Squadra:</strong> {player.Squadra} <br />
                            <strong>Media Voto:</strong> {player['Media Voto'] ?? '—'} <br />
                            <strong>Fantamedia:</strong> {player['Media FantaVoto'] ?? '—'} <br />
                            <strong>FVM:</strong>{' '}
                            {Number.isFinite(fvm) ? Math.floor(fvm / 2) : '—'}
                        </p>
                        {clubLogo(player.Squadra) && (
                            <img
                                src={clubLogo(player.Squadra)}
                                alt={player.Squadra}
                                className="player-club"
                            />
                        )}
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}
